import React from 'react';
import { LockClosedIcon, LockOpenIcon } from '@heroicons/react/24/outline';
import {
  LockClosedIcon as LockClosedIconSolid,
  LockOpenIcon as LockOpenIconSolid,
} from '@heroicons/react/24/solid';
import styles from './styles.module.scss';

/**
 * LockControl Component
 *
 * Radio-style Lock/Unlock toggle with status message.
 */
const LockControl = ({
  lockStatus,
  hasLock,
  onAcquireLock,
  onReleaseLock,
  onForceOverride,
  isLoading = false,
}) => {
  const { locked, locked_by_name } = lockStatus || {};

  const getStatusMessage = () => {
    if (hasLock) return 'You\'re editing — others cannot edit.';
    if (locked && locked_by_name) return `${locked_by_name} is editing — click to take over.`;
    return 'No one is editing — lock to start editing.';
  };

  const handleLockChange = (wantsLock) => {
    if (isLoading) return;
    if (wantsLock) {
      if (hasLock) return;
      locked ? onForceOverride() : onAcquireLock();
    } else {
      if (!hasLock) return;
      onReleaseLock();
    }
  };

  const controlClass = [
    styles.lockControl,
    hasLock && styles.hasLock,
    locked && !hasLock && styles.lockedByOther,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={controlClass}>
      <div className={styles.radioGroup}>
        <label className={`${styles.radioOption} ${hasLock ? styles.radioSelected : ''}`}>
          <input
            type="radio"
            name="lock-control"
            checked={hasLock}
            onChange={() => handleLockChange(true)}
            disabled={isLoading}
            className={styles.radioInput}
          />
          <span className={styles.radioIcon}>
            {hasLock ? <LockClosedIconSolid className={styles.icon} /> : <LockClosedIcon className={styles.icon} />}
          </span>
          <span className={styles.radioLabel}>I'm editing</span>
        </label>

        <label className={`${styles.radioOption} ${!hasLock ? styles.radioSelected : ''}`}>
          <input
            type="radio"
            name="lock-control"
            checked={!hasLock}
            onChange={() => handleLockChange(false)}
            disabled={isLoading}
            className={styles.radioInput}
          />
          <span className={styles.radioIcon}>
            {!hasLock ? <LockOpenIconSolid className={styles.icon} /> : <LockOpenIcon className={styles.icon} />}
          </span>
          <span className={styles.radioLabel}>Release</span>
        </label>
      </div>

      <div className={`${styles.statusMessage} ${hasLock ? styles.statusLocked : styles.statusUnlocked}`}>
        {isLoading ? (
          <>
            <span className={styles.spinner} />
            {hasLock ? 'Releasing...' : locked ? 'Taking over...' : 'Acquiring...'}
          </>
        ) : (
          getStatusMessage()
        )}
      </div>
    </div>
  );
};

export default LockControl;

